import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.unlockUserRequest.pageTitle',
    defaultMessage: 'Richiesta sblocco utenza',
    description: 'Title of the unlock user request page',
  },
  pageSubtitle: {
    id: 'features.unlockUserRequest.pageSubtitle',
    // eslint-disable-next-line quotes
    defaultMessage: "Procedi con lo sblocco dell'utenza",
    description: 'Subtitle of the unlock user request page',
  },
  buttonUnlockUserRequest: {
    id: 'features.unlockUserRequest.buttonUnlockUserRequest',
    defaultMessage: 'Procedi',
    description: 'Label of the unlock user request button',
  },
  backTo: {
    id: 'features.unlockUserRequest.backTo',
    defaultMessage: 'Annulla',
    description: 'Back link',
  },
  disclaimerUnlockUserRequest: {
    id: 'features.unlockUserRequest.disclaimerUnlockUserRequest',
    defaultMessage:
      'L’utenza è stata cautelativamente bloccata in seguito ad un certo numero errato di autenticazioni. Procedere allo sblocco tramite email?',
    description: 'Text of disclaimer',
  },
});
